export default "__VITE_ASSET__Dw$1nCjS__"